import { v4 } from 'uuid';
import { SnackbarNotificationMessageType } from './SnackbarNotificationMessageType';

export class SnackbarNotificationMessageQueueItem {
    id: string;
    messageType: SnackbarNotificationMessageType;
    message: string;
    hasButton: boolean;
    displayTime: number;

    private constructor(messageType: SnackbarNotificationMessageType | undefined, message: string | undefined, hasButton = false, displayTime = 3000) {
        if (messageType === undefined) {
            throw new Error('messageType undefined');
        }
        if (message === undefined) {
            throw new Error('message undefined');
        }
        if (displayTime < 0) {
            throw new Error('No negative numbers allowed');
        }

        this.id = v4();
        this.messageType = messageType;
        this.message = message;
        this.hasButton = hasButton;
        this.displayTime = displayTime;
    }

    static create({
        messageType,
        message,
        displayTime,
    }: {
        messageType: SnackbarNotificationMessageType | undefined;
        message: string | undefined;
        displayTime?: number;
    }): SnackbarNotificationMessageQueueItem {
        return new SnackbarNotificationMessageQueueItem(messageType, message, false, displayTime);
    }

    static createWithButton({
        messageType,
        message,
        displayTime,
    }: {
        messageType: SnackbarNotificationMessageType | undefined;
        message: string | undefined;
        displayTime?: number;
    }): SnackbarNotificationMessageQueueItem {
        return new SnackbarNotificationMessageQueueItem(messageType, message, true, displayTime);
    }
}
